import {
  getDocumentHtmlContent,
  getDocumentNlHtmlContent,
  stripHtmlForPreview,
} from "./cmsDocumentUtils";

export const EMPTY_DOCUMENT_FORM = {
  title: "",
  title_nl: "",
  type: "",
  content: "",
  content_nl: "",
  visibility: "EVERYONE",
  change_summary: "",
};

export const VISIBILITY_HELP = {
  EVERYONE: "Available to everyone who can access the public website.",
  BUYERS_ONLY: "Available only to authenticated buyers.",
  SELLERS_ONLY: "Available only to authenticated sellers.",
};

export const LANGUAGE_CONFIG = {
  EN: {
    titleKey: "title",
    contentKey: "content",
    name: "English",
    description: "English title and content",
    titlePlaceholder: "e.g. Return Policy",
    contentPlaceholder: "Write the English document…",
  },
  NL: {
    titleKey: "title_nl",
    contentKey: "content_nl",
    name: "Nederlands",
    description: "Dutch title and content",
    titlePlaceholder: "bijv. Retourbeleid",
    contentPlaceholder: "Schrijf het Nederlandse document…",
  },
};

export const mapDocumentToForm = (document) => ({
  title: document.title || "",
  title_nl: document.titleNl || "",
  type: document.type || "",
  content: getDocumentHtmlContent(document),
  content_nl: getDocumentNlHtmlContent(document),
  visibility: document.visibility || "EVERYONE",
  change_summary: "",
});

export const validateDocumentForm = (form, t = (key) => key) => {
  const errors = {};

  if (!form.title.trim()) errors.title = t("cmsDocuments.validation.englishTitleRequired");
  if (!form.title_nl.trim()) errors.title_nl = t("cmsDocuments.validation.dutchTitleRequired");
  if (!form.type) errors.type = t("cmsDocuments.validation.typeRequired");
  if (!form.visibility) errors.visibility = t("cmsDocuments.validation.visibilityRequired");

  if (stripHtmlForPreview(form.content) === "No content available") {
    errors.content = t("cmsDocuments.validation.englishContentRequired");
  }

  if (stripHtmlForPreview(form.content_nl) === "No content available") {
    errors.content_nl = t("cmsDocuments.validation.dutchContentRequired");
  }

  return errors;
};

export const buildDocumentPayload = (form, status, includeChangeSummary) => {
  const payload = {
    title: form.title.trim(),
    title_nl: form.title_nl.trim(),
    document_type: form.type,
    visibility: form.visibility,
    status,
    content: form.content,
    content_nl: form.content_nl,
  };

  if (includeChangeSummary && form.change_summary.trim()) {
    payload.change_summary = form.change_summary.trim();
  }

  return payload;
};

export const isLanguageComplete = (form, language) => {
  const config = LANGUAGE_CONFIG[language];
  const hasTitle = Boolean(form[config.titleKey].trim());
  const hasContent =
    stripHtmlForPreview(form[config.contentKey]) !== "No content available";

  return hasTitle && hasContent;
};

export const getLanguageForErrors = (errors) => {
  if (errors.title || errors.content) return "EN";
  if (errors.title_nl || errors.content_nl) return "NL";
  return null;
};
